import React from 'react';
import { Shield, Network, Bug, Server, Package } from 'lucide-react';

const iconMap = {
  Shield: Shield,
  Network: Network,
  Bug: Bug,
  Server: Server,
  Package: Package
};

const ServiceCard = ({ service, detailed = false }) => {
  const IconComponent = iconMap[service.icon];

  return (
    <div className="service-card">
      <div className="service-icon">
        {IconComponent && <IconComponent size={detailed ? 48 : 40} />}
      </div>
      <h3 className="service-title">{service.title}</h3>
      <p className="service-description">{service.description}</p>
      {detailed && service.details && (
        <p className="service-details">{service.details}</p>
      )}
    </div>
  );
};

export default ServiceCard;